<template>

    <div>
        <h4>{{value.Subject || '-'}}</h4>
        
        <br/>
        <p class="card-text" v-html="value.Content" />
       
    </div>
    
    
</template>

<script>
export default {
    props:{
        value:Object
    },
    
}
</script>

<style>

</style>